<template>
</template>
<script>
/**
 * only provides current color variant as prop for styling to components which directly need it
 */
import { mapGetters } from 'vuex'

export default {
    name: 'colorVariantMixin',
    computed: {
        ...mapGetters([
            'colorVariant'
        ]),
        baseColor() {
            const colors = {
                'bq-green': '#00A883',
                'bq-blue': '#32769C',
                'bq-red': '#DC4D45',
                'bq-turquoise': '#369BA6',
                'bq-darkgrey': '#707070',
                'bq-burgundy': '#A84872',
                'bq-orange': '#F09C65'
            }
           
            return colors[this.colorVariant] || '#000' 
        },
        baseColorLight() {
            const colorsLight = {
                'bq-green': '#DBF3ED',
                'bq-blue': '#78aecc',
                'bq-red': '#dd9794',
                'bq-turquoise': '#96d3da',
                'bq-burgundy': '#db91b1',
                'bq-orange': '#f7c9ab'
            }
           
            return colorsLight[this.colorVariant] || '#000' 
        }
    },
    methods: {
        injectCurrentVariant() {
            return { '--current-variant-color': this.baseColor }
        }
    }
}
</script>
<style lang="scss">
    .color-current-variant {
        color: var(--current-variant-color);
    }
</style>